declare const IMP: any;

export const iamPort = ({ requestIMP, responseIMP }: { requestIMP: object; responseIMP: any }) => {
    IMP.init("imp75438184");
    IMP.request_pay(requestIMP, responseIMP);
};
